export { default } from './svg/chevron-right.svg';
